import addClasses from './addClasses.js';
import removeClasses from './removeClasses.js';
export default {
  addClasses,
  removeClasses
};


//////////////////
// WEBPACK FOOTER
// /Users/maciekbaron/Development/seuk-fe/web/app/themes/seuk/node_modules/swiper/core/classes/index.js
// module id = 136
// module chunks = 0